import { Row } from '@unistocks/components/layout/flex';
import { Paragraph } from '@unistocks/components/text/text';
import { t } from '@unistocks/localization';
import { HOME_PAGE_URL } from '@unistocks/shared/consts';
import React from 'react';
import { Anchor } from 'tamagui';

export const TermsAndConditionsAccept: React.FC = () => {
  return (
    <Row flexWrap="wrap" mt={'$7'} alignItems={'center'} justifyContent={'center'}>
      <Paragraph size={'$3'}>{t('AbpAccount::Register:TermsAndConditions')}</Paragraph>

      <Anchor
        size={'$3'}
        color={'$unistocks'}
        textDecorationLine={'underline'}
        href={`${HOME_PAGE_URL}/terms-of-service`}
      >
        {t('::TermsAndConditions')}
      </Anchor>

      <Paragraph size={'$3'} verticalAlign={'top'}>
        {t('::And')}
      </Paragraph>

      <Anchor
        size={'$3'}
        color={'$unistocks'}
        textDecorationLine={'underline'}
        href={`${HOME_PAGE_URL}/privacy-policy`}
      >
        {t('::PrivacyPolicy')}
      </Anchor>
    </Row>
  );
};

TermsAndConditionsAccept.displayName = 'TermsAndConditionsAccept';
